import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";
import { gradientBackgrounds } from "@/components/AIComponents/AiComponents.style";

const { colors } = constants;
const white = colors.ui.white[500];

export const previewContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "16px",
  width: "947px",
  background: gradientBackgrounds[100],
  borderRadius: "16px",
  height: "fit-content",
};

export const templateContainerCss: CSSObject = {
  width: "100%",
  height: "100%",
  background: white,
};

export const templateFormCss: CSSObject = {
  height: "100%",
};
